import { CSSProperties } from 'react'

/**
 * Shared chrome for the tool-call pills: a single call and a collapsed run.
 * Friendly labels (compact tool calls on) read as prose in the app font; raw
 * tool names stay monospace.
 */
export function toolTagStyle(compactToolCalls: boolean): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontFamily: compactToolCalls ? 'inherit' : 'monospace',
    fontSize: 12,
    borderRadius: 12,
    padding: '2px 10px',
    background: '#f5f5f5',
    border: '1px solid #d9d9d9',
  }
}
